import { gql } from '@apollo/client';

export const UNASSIGN_LOCATION_PERSON_MUTATION = gql(
  `
    mutation UnassignLocationPersonMutation(  $locationId:UUID!,$personIds: [UUID!]!){
        unassignLocationPersons(
        input:{ locationId: $locationId,personIds: $personIds}){
          location {
            id
          }
        }
    }

    `
)

export const UNASSIGN_PERSON_LOCATIONS_MUTATION = gql(
  `
    mutation UnassignPersonLocationsMutation( $personId:UUID!,$locationIds: [UUID!]!){
        unassignPersonLocations(
        input:{personId: $personId,locationIds: $locationIds}){
          person {
            id
          }
        }
    }

    `
)